import * as types from "./mutation-types";

export default {
  /**
   * Salva o último evento da página para um possível uso, como a abertura de uma nova janela.
   */
  [types.SAVE_EVENT](state, payload) {
    if (Array.isArray(payload.data)) {
      payload.data.forEach((evt) => {
        if (!state.events[evt.event]) {
          state.events[evt.event] = [];
          state.events[evt.event].push(evt);
        } else {
          var index = -1;
          if (evt.event == "MARK") {
            index = state.events[evt.event].findIndex((x) => x.id == evt.id);
          } else if (evt.event == "HORIZONTAL_LINE") {
            index = state.events[evt.event].findIndex(
              (x) => parseFloat(x.price) == parseFloat(evt.price)
            );
          } else if (evt.event == "VERTICAL_LINE") {
            index = state.events[evt.event].findIndex(
              (x) => Number(x.time) == Number(evt.time)
            );
          } else {
            index = state.events[evt.event].findIndex(
              (x) => Number(x.investment_id) == Number(evt.investment_id)
            );
          }
          if (index == -1) {
            state.events[evt.event].push(evt);
          } else {
            state.events[evt.event][index] = evt;
          }
        }
      });
    }
    state.events = { ...state.events };
  },
  [types.CLOSE_POSITION](state, payload) {
    var updatedPositions = state.events["NEW_POSITION"];
    payload.data.forEach((prop) => {
      if (updatedPositions) {
        state.events["NEW_POSITION"] = updatedPositions.filter(
          (x) => Number(x.investment_id) != Number(prop.investment_id)
        );
        if (state.events["NEW_POSITION"].length == 0)
          delete state.events["NEW_POSITION"];
      }
    });
  },
  /**
   * Limpa o evento pelo tipo.
   * @param {*} payload nome do evento
   */
  [types.CLEAN_EVENT](state, payload) {
    if (state.events[payload]) {
      delete state.events[payload];
    }
  },
  [types.CLEAN_ALL_EVENT](state) {
    state.events = {};
  },
  /**
   * Exclui evento pelo investment_id.
   * @param {*} payload | investment_id
   */
  [types.CLEAN_EVENT_BY_INVESTMENT_ID](state, payload) {
    if (state.events["NEW_POSITION"]) {
      state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(
        (x) => Number(x.investment_id) != Number(payload)
      );
    }
  },
  /**
   * Salva na lista de notificações gerais do usuário.
   */
  [types.SAVE_NOTIFICATION](state, payload) {
    // //console.log("MUTATION[SAVE_NOTIFICATION] ~ payload:", payload);
    // state.notifications.push(payload);
  },

  [types.STRATEGY_GAIN](state, payload) {
    payload.data.forEach((evt) => {
      if (!state.events[evt.notif_type]) {
        state.events[evt.notif_type] = [];
        state.events[evt.notif_type].push(evt);
        //         if (state.events["NEW_POSITION"]) {
        //           state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
        //         }
      } else {
        var index = state.events[evt.notif_type].findIndex(
          (x) => Number(x.investment_id) == Number(evt.investment_id)
        );
        if (index == -1) {
          state.events[evt.notif_type].push(evt);
          //           if (state.events["NEW_POSITION"]) {
          //             state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
          //           }
        } else {
          state.events[evt.notif_type][index] = evt;
          //           if (state.events["NEW_POSITION"]) {
          //             state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
          //           }
        }
      }
    });
  },
  [types.STRATEGY_LOSS](state, payload) {
    payload.data.forEach((evt) => {
      if (!state.events[evt.notif_type]) {
        state.events[evt.notif_type] = [];
        state.events[evt.notif_type].push(evt);
        //         if (state.events["NEW_POSITION"]) {
        //           state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
        //         }
      } else {
        var index = state.events[evt.notif_type].findIndex(
          (x) => Number(x.investment_id) == Number(evt.investment_id)
        );
        if (index == -1) {
          state.events[evt.notif_type].push(evt);
          //           if (state.events["NEW_POSITION"]) {
          //             state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
          //           }
        } else {
          state.events[evt.notif_type][index] = evt;
          //           if (state.events["NEW_POSITION"]) {
          //             state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
          //           }
        }
      }
    });
  },
  [types.STRATEGY_TIME](state, payload) {
    payload.data.forEach((evt) => {
      if (!state.events[evt.notif_type]) {
        state.events[evt.notif_type] = [];
        state.events[evt.notif_type].push(evt);
        //         if (state.events["NEW_POSITION"]) {
        //           state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
        //         }
      } else {
        var index = state.events[evt.notif_type].findIndex(
          (x) => Number(x.investment_id) == Number(evt.investment_id)
        );
        if (index == -1) {
          state.events[evt.notif_type].push(evt);
          //           if (state.events["NEW_POSITION"]) {
          //             state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
          //           }
        } else {
          state.events[evt.notif_type][index] = evt;
          //           if (state.events["NEW_POSITION"]) {
          //             state.events["NEW_POSITION"] = state.events["NEW_POSITION"].filter(x => Number(x.investment_id) == Number(evt.investment_id));
          //           }
        }
      }
    });
  },
};
